import React, { useEffect } from "react";

import etg from "../../../assets/img/brands/etg.png";
import kynoch from "../../../assets/img/brands/kynoch.png";
import falcon from "../../../assets/img/brands/falcon.png";
import oemff from "../../../assets/img/brands/oemff.png";
import "./Brands.css";
import { Link } from "react-router-dom";
import { useListAllBrandQuery } from "../../products/productSlice";
import axios from "axios";
import { AiFillCar } from "react-icons/ai";
import { RiArrowGoForwardLine } from "react-icons/ri";
import { FaMoneyBill } from "react-icons/fa";
import { BsShieldLockFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";

const imgs = [etg, kynoch, falcon, oemff];

function Brands() {
  const { t } = useTranslation();
  // const { data, isLoading, error } = useListAllBrandQuery()

  return (
    <>
      <section className="brandPart">
        <div className="container">
          <div className="brandsSec bgLiteGreen p-5">
            <div className="row">
              <div className="mainRap col-lg-12">
                <div className="icon">
                  <AiFillCar />
                </div>
                <div className="text">
                  <h6>{t("Horticulture and Landscaping")}</h6>
                  <p>
                    At Vinca Horticulture & Landscape Pvt. Ltd., we believe that
                    a well-designed landscape is not just about aesthetics — it
                    is about creating harmony between nature and modern living.
                    With a perfect blend of horticultural expertise and
                    innovative landscaping techniques, we turn ordinary spaces
                    into refreshing green environments that enhance beauty,
                    comfort, and sustainability.
                  </p>
                </div>
              </div>
              {/* <div className="mainRap col-lg-3 col-md-3 col-sm-6 col-6">
              <div className="icon">
                <AiFillCar />
              </div>
              <div className="text">
                <h6>{t("Free Shipping")}</h6>
                <p>
                  {t("shippingText")}
                </p>
              </div>
            </div>
            <div className="mainRap col-lg-3 col-md-3 col-sm-6 col-6">
              <div className="icon">
                <RiArrowGoForwardLine />
              </div>
              <div className="text">
                <h6> {t("Full Refund")}</h6>
                <p>
                  {t("refundText")}
                  
                </p>
              </div>
            </div>
            <div className="mainRap col-lg-3 col-md-3 col-sm-6 col-6">
              <div className="icon">
                <FaMoneyBill />
              </div>
              <div className="text">
                <h6>{t("Debit & Credit Card")}</h6>
                <p>
                 {t("debitText")}
                </p>
              </div>
            </div>
            <div className="mainRap col-lg-3 col-md-3 col-sm-6 col-6">
              <div className="icon">
                <BsShieldLockFill />
              </div>
              <div className="text">
                <h6>{t("100% Secure Payment")}</h6>
                <p>
                 {t("paymentText & Credit Card")} 
                </p>
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Brands;
